module.exports = __webpack_public_path__ + "img/Add_to_Apple_Wallet_rgb_US-UK.15b0f130.svg";